// Use a uniquely generated device-specific salt for encrypting the local offline cache.
        // We no longer expose this on `window.APP_SECRET` to break simple console injection scripts.
        (function initDeviceSalt() {
            localStorage.removeItem('qr_bloom_device_salt'); // Cleanup legacy plaintext key
            if (!localStorage.getItem('__qrb_sys_hash')) {
                const salt = Array.from({ length: 64 }, () => Math.floor(Math.random() * 16).toString(16)).join('');
                localStorage.setItem('__qrb_sys_hash', btoa(salt + (navigator.userAgent || '')).split('').reverse().join(''));
            }
        })();

        function _getAppSecret() {
            try {
                let enc = localStorage.getItem('__qrb_sys_hash');
                if (!enc) return 'fallback_secret_qrb';
                let dec = atob(enc.split('').reverse().join(''));
                return dec.replace(navigator.userAgent || '', '');
            } catch (e) { return 'fallback_secret_qrb'; }
        }
        const originalGetItem = Storage.prototype.getItem;
        const originalSetItem = Storage.prototype.setItem;
        const originalRemoveItem = Storage.prototype.removeItem;

        window.originalGetItem = originalGetItem;
        window.originalSetItem = originalSetItem;
        window.originalRemoveItem = originalRemoveItem;
        window.__nativeStorageGet = originalGetItem;

        const MOBILE_SYNC_KEYS = [
            'active_layer_mode', 'suite_sound_muted', 'suite_sound_volume',
            'suite_typing_enabled', 'suite_typing_volume', 'suite_typing_tune',
            'suite_bottom_nav_enabled', 'suite_bottom_nav_volume',
            'nav_anim_enabled', 'session_protocol_enabled', 'fullscreen_on_click'
        ];

        // ── Secure Cache Decryption & Signature Verification Helper ──
        function getVerifiedPlanFromCache() {
            try {
                // Read encrypted cache directly using the original prototype to bypass interception
                const enc = originalGetItem.call(localStorage, 'qrbloom_sub_enc');
                if (!enc) return 'normal';

                const b = CryptoJS.AES.decrypt(enc, _getAppSecret());
                const obj = JSON.parse(b.toString(CryptoJS.enc.Utf8));

                const user = (window.suiteAuth && window.suiteAuth.currentUser) || (window.auth && window.auth.currentUser);

                // ── Phase 1: Cold-start (auth not yet loaded) ──
                // Allow soft-read: verify signature only using uid stored in cache.
                // This lets Ultra users see their plan immediately on load.
                // BloomSubscription.verifyAndApply() will re-check with full UID after auth loads.
                const uid = user ? user.uid : obj.uid;
                if (!uid) return 'normal';

                // ── Phase 2: If auth IS loaded, enforce UID match ──
                if (user && obj.uid !== user.uid) return 'normal';

                const signPayload = uid + obj.plan + (obj.expiresAtMs || 0) + _getAppSecret();
                const expectedSignature = CryptoJS.SHA256(signPayload).toString();
                if (obj.signature !== expectedSignature) return 'normal';

                const now = Date.now();
                const exMs = obj.expiresAtMs || 0;
                const isActive = (obj.plan === 'foundation' || obj.plan === 'normal') ? true : (exMs > now && obj.status === 'active');
                if (!isActive) return 'normal';

                const TIER_TO_INTERNAL = { 'foundation': 'normal', 'velocity': 'max', 'quantum': 'pro', 'ultra': 'ultra' };
                return TIER_TO_INTERNAL[obj.plan] || 'normal';
            } catch (e) {
                return 'normal';
            }
        }

        const RESTRICTED_STORAGE_KEYS = [
            'dynamic_qr_stats',
            'had_premium_plan',
            'last_notified_subscription',
            'qr_batch_usage',
            'qr_dynamic',
            'qr_selected_type',
            'qr_total_created',
            'qr_total_decoded',
            'qrbloom_scanned_dyn_qrs',
            'user_subscription'
        ];
        window.RESTRICTED_STORAGE_KEYS = RESTRICTED_STORAGE_KEYS;

        // Immediately purge any restricted keys from localStorage on load
        (function purgeRestrictedKeys() {
            RESTRICTED_STORAGE_KEYS.forEach(k => {
                try { originalRemoveItem.call(localStorage, k); } catch (e) { }
            });
        })();

        // ── Direct Property Traps on Storage.prototype & localStorage (blocks localStorage.user_subscription = 'ultra') ──
        (function trapStorageProperties() {
            RESTRICTED_STORAGE_KEYS.forEach(key => {
                const descriptor = {
                    get: function () {
                        if (key === 'user_subscription') {
                            if (window.BloomSubscription && typeof window.BloomSubscription.getActivePlan === 'function') {
                                return window.BloomSubscription.getActivePlan();
                            }
                            return getVerifiedPlanFromCache();
                        }
                        if (key === 'premiumActive') {
                            if (window.BloomSubscription && typeof window.BloomSubscription.isPlanActive === 'function') {
                                return window.BloomSubscription.isPlanActive() ? 'true' : 'false';
                            }
                            return getVerifiedPlanFromCache() !== 'normal' ? 'true' : 'false';
                        }
                        if (key === 'had_premium_plan') return 'false';
                        if (key === 'qr_batch_usage') return String(window._qrbloom_batch_usage || 0);
                        if (key === 'qr_dynamic') return String(window._qrbloom_dynamic_usage || 0);
                        if (key === 'qr_selected_type') return window._qrbloom_selected_type || 'text';
                        if (key === 'qr_total_created') return String(window._qrbloom_total_created || 0);
                        if (key === 'qr_total_decoded') return String(window._qrbloom_total_decoded || 0);
                        if (key === 'dynamic_qr_stats') return JSON.stringify(window._qrbloom_dynamic_qr_stats || {});
                        if (key === 'qrbloom_scanned_dyn_qrs') return JSON.stringify(Array.from(window._qrbloom_scanned_dyn_qrs || []));
                        return undefined;
                    },
                    set: function (val) {
                        try { originalRemoveItem.call(this, key); } catch (e) { }
                        try { originalRemoveItem.call(localStorage, key); } catch (e) { }
                        if (key === 'user_subscription') {
                            const authenticPlan = (window.BloomSubscription && typeof window.BloomSubscription.getActivePlan === 'function')
                                ? window.BloomSubscription.getActivePlan()
                                : getVerifiedPlanFromCache();
                            window.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { key: 'user_subscription', val: authenticPlan } }));
                            window.dispatchEvent(new CustomEvent('qrbloom_plan_tampered', { detail: { plan: authenticPlan } }));
                            document.querySelectorAll('iframe').forEach(iframe => {
                                try {
                                    if (iframe.contentWindow) {
                                        iframe.contentWindow.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { key: 'user_subscription', val: authenticPlan } }));
                                        iframe.contentWindow.dispatchEvent(new CustomEvent('qrbloom_plan_tampered', { detail: { plan: authenticPlan } }));
                                    }
                                } catch (err) { }
                            });
                        }
                    },
                    configurable: true,
                    enumerable: true
                };
                try { Object.defineProperty(Storage.prototype, key, descriptor); } catch (e) { }
                try { Object.defineProperty(localStorage, key, descriptor); } catch (e) { }
            });
        })();

        // ── Intercept Storage.prototype.getItem to prevent LocalStorage tampering ──
        Object.defineProperty(Storage.prototype, 'getItem', {
            value: function (key) {
                if (key === 'user_subscription') {
                    if (window.BloomSubscription && typeof window.BloomSubscription.getActivePlan === 'function') {
                        return window.BloomSubscription.getActivePlan();
                    }
                    return getVerifiedPlanFromCache();
                }
                if (key === 'premiumActive') {
                    if (window.BloomSubscription && typeof window.BloomSubscription.isPlanActive === 'function') {
                        return window.BloomSubscription.isPlanActive() ? 'true' : 'false';
                    }
                    return getVerifiedPlanFromCache() !== 'normal' ? 'true' : 'false';
                }
                if (key === 'had_premium_plan') {
                    return 'false';
                }
                if (key === 'qr_batch_usage') {
                    return String(window._qrbloom_batch_usage || 0);
                }
                if (key === 'qr_dynamic') {
                    return String(window._qrbloom_dynamic_usage || 0);
                }
                if (key === 'qr_selected_type') {
                    return window._qrbloom_selected_type || 'text';
                }
                if (key === 'qr_total_created') {
                    return String(window._qrbloom_total_created || 0);
                }
                if (key === 'qr_total_decoded') {
                    return String(window._qrbloom_total_decoded || 0);
                }
                if (key === 'dynamic_qr_stats') {
                    return JSON.stringify(window._qrbloom_dynamic_qr_stats || {});
                }
                if (key === 'qrbloom_scanned_dyn_qrs') {
                    return JSON.stringify(Array.from(window._qrbloom_scanned_dyn_qrs || []));
                }
                if (MOBILE_SYNC_KEYS.includes(key)) {
                    return originalGetItem.call(this, 'mobile_' + key);
                }
                return originalGetItem.call(this, key);
            },
            writable: false, configurable: false
        });

        Object.defineProperty(Storage.prototype, 'setItem', {
            value: function (key, val) {
                if (RESTRICTED_STORAGE_KEYS.includes(key)) {
                    // Strictly prevent saving any non-user setting keys to localStorage
                    originalRemoveItem.call(this, key);
                    if (key === 'qr_batch_usage') {
                        window._qrbloom_batch_usage = parseInt(val) || 0;
                        if (typeof window.syncBatchUsageToFirebase === 'function') window.syncBatchUsageToFirebase(window._qrbloom_batch_usage);
                    } else if (key === 'qr_dynamic') {
                        window._qrbloom_dynamic_usage = parseInt(val) || 0;
                        if (typeof window.syncDynamicUsageToFirebase === 'function') window.syncDynamicUsageToFirebase(window._qrbloom_dynamic_usage);
                    } else if (key === 'qr_selected_type') {
                        window._qrbloom_selected_type = val;
                    } else if (key === 'qr_total_created') {
                        window._qrbloom_total_created = parseInt(val) || 0;
                    } else if (key === 'qr_total_decoded') {
                        window._qrbloom_total_decoded = parseInt(val) || 0;
                    } else if (key === 'dynamic_qr_stats') {
                        try { window._qrbloom_dynamic_qr_stats = typeof val === 'string' ? JSON.parse(val) : val; } catch (e) { }
                    } else if (key === 'qrbloom_scanned_dyn_qrs') {
                        try { window._qrbloom_scanned_dyn_qrs = new Set(typeof val === 'string' ? JSON.parse(val) : val); } catch (e) { }
                    } else if (key === 'user_subscription') {
                        // Instant revert to authentic Firebase plan
                        const truePlan = (window.BloomSubscription && typeof window.BloomSubscription.getActivePlan === 'function')
                            ? window.BloomSubscription.getActivePlan()
                            : getVerifiedPlanFromCache();
                        window.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { key: 'user_subscription', val: truePlan } }));
                        window.dispatchEvent(new CustomEvent('qrbloom_plan_tampered', { detail: { plan: truePlan } }));
                        document.querySelectorAll('iframe').forEach(iframe => {
                            try {
                                if (iframe.contentWindow) {
                                    iframe.contentWindow.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { key: 'user_subscription', val: truePlan } }));
                                    iframe.contentWindow.dispatchEvent(new CustomEvent('qrbloom_plan_tampered', { detail: { plan: truePlan } }));
                                }
                            } catch (err) { }
                        });
                    }
                    return;
                }
                if (MOBILE_SYNC_KEYS.includes(key)) {
                    return originalSetItem.call(this, 'mobile_' + key, val);
                }
                return originalSetItem.call(this, key, val);
            },
            writable: false, configurable: false
        });

        Object.defineProperty(Storage.prototype, 'removeItem', {
            value: function (key) {
                if (RESTRICTED_STORAGE_KEYS.includes(key)) {
                    if (key === 'qr_batch_usage') window._qrbloom_batch_usage = 0;
                    if (key === 'qr_dynamic') window._qrbloom_dynamic_usage = 0;
                    if (key === 'qr_selected_type') window._qrbloom_selected_type = 'text';
                    if (key === 'qr_total_created') window._qrbloom_total_created = 0;
                    if (key === 'qr_total_decoded') window._qrbloom_total_decoded = 0;
                    if (key === 'dynamic_qr_stats') window._qrbloom_dynamic_qr_stats = {};
                    if (key === 'qrbloom_scanned_dyn_qrs') window._qrbloom_scanned_dyn_qrs = new Set();
                    return originalRemoveItem.call(this, key);
                }
                if (MOBILE_SYNC_KEYS.includes(key)) {
                    return originalRemoveItem.call(this, 'mobile_' + key);
                }
                return originalRemoveItem.call(this, key);
            },
            writable: false, configurable: false
        });

        /* --- SAFE LOCALSTORAGE WRAPPER (fixes Chrome file:// crash) --- */
        window.safeStorage = {
            getItem: function (key) { try { return localStorage.getItem(key); } catch (e) { return null; } },
            setItem: function (key, val, isRemote = false) {
                try {
                    localStorage.setItem(key, val);
                    window.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { key, val, isRemote } }));
                    if (window.parent && window.parent !== window) {
                        try { window.parent.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { key, val, isRemote } })); } catch (err) { }
                    }
                    document.querySelectorAll('iframe').forEach(iframe => {
                        try {
                            if (iframe.contentWindow) {
                                iframe.contentWindow.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { key, val, isRemote } }));
                            }
                        } catch (err) { }
                    });
                } catch (e) { }
            },
            removeItem: function (key) {
                try {
                    localStorage.removeItem(key);
                    window.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { key, val: null } }));
                    if (window.parent && window.parent !== window) {
                        try { window.parent.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { key, val: null } })); } catch (err) { }
                    }
                    document.querySelectorAll('iframe').forEach(iframe => {
                        try {
                            if (iframe.contentWindow) {
                                iframe.contentWindow.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { key, val: null } }));
                            }
                        } catch (err) { }
                    });
                } catch (e) { }
            },
            clear: function () {
                try {
                    localStorage.clear();
                    window.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { clear: true } }));
                    if (window.parent && window.parent !== window) {
                        try { window.parent.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { clear: true } })); } catch (err) { }
                    }
                    document.querySelectorAll('iframe').forEach(iframe => {
                        try {
                            if (iframe.contentWindow) {
                                iframe.contentWindow.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { clear: true } }));
                            }
                        } catch (err) { }
                    });
                } catch (e) { }
            }
        };
        const safeStorage = window.safeStorage;

        // 📊 GLOBAL ANALYTICS BRIDGE [RESILIENT & LOCAL-ONLY]
        window.bloomAnalytics = {
            ready: true,
            logQRScan: (qr_id, qr_type, scan_source) => {
            },
            logQRGenerate: (qr_id, qr_type, design_id) => {
            },
            logQRShare: (qr_id, platform, share_method) => {
            },
            logNotification: (title, message, type) => {
            },
            logScreenView: (screen_name) => {
            },
            logAuthAction: (action, method) => {
            },
            logSettingsUpdate: (setting_count) => {
            },
            logFavoriteSync: (action, item_id) => {
            },
            logLinkAction: (action_type, target_url, status = 'attempt') => {
            },
            logError: (message, context) => {
            }
        };

        // --- Parent Database & Plan limits Single Source of Truth ---
        window.planFullData = {
            'normal': {
                name: "FOUNDATION",
                features: ["15 QR Slots", "Unlimited Decoding", "15 QR Decoding History", "50 Barcode Decoding History", "Basic Frames", "Standard Logos", "No Custom Logo Uploads", "0 Batch QR Creation", "Full Analytics", "Basic PDF Reports"]
            },
            'max': {
                name: "VELOCITY",
                features: ["50 QR Slots", "Unlimited Decoding", "25 QR Decoding History", "50 Barcode Decoding History", "10+ Premium Frames", "15+ Enhanced Logos", "Email Support", "0 Batch QR Creation", "Full Analytics", "Standard PDF Reports"]
            },
            'pro': {
                name: "QUANTUM",
                features: ["100 QR Slots", "Unlimited Decoding", "75 QR Decoding History", "50 Barcode Decoding History", "25+ Cyber Frames", "30+ Professional Logos", "Custom Logo Uploads", "15 Batch QR Creations", "Waveform Data Sync", "Barcode Creation & Decoding (Premium)", "Priority Support"]
            },
            'ultra': {
                name: "ULTRA",
                features: ["300 QR Slots", "Unlimited Decoding", "500 QR Decoding History", "50 Barcode Decoding History", "50+ Genesis Frames", "50+ Genesis Logos", "Custom Logo Uploads", "25 Batch QR Creations", "Hardware Accel v2", "Barcode Creation & Decoding (Premium)", "Full API Interface", "24/7 Priority Ops"]
            }
        };

        window.getCurrentStorageLimits = function () {
            let sub = 'normal';
            if (window.BloomSubscription && typeof window.BloomSubscription.getActivePlan === 'function') {
                sub = window.BloomSubscription.getActivePlan();
            } else if (typeof getVerifiedPlanFromCache === 'function') {
                sub = getVerifiedPlanFromCache();
            }

            const plan = window.planFullData[sub] || window.planFullData['normal'];
            const getLimit = (pattern, fallback) => {
                const feature = plan.features.find(f => f.includes(pattern));
                if (!feature) return parseInt(fallback);
                const match = feature.match(/\d+/);
                return match ? parseInt(match[0]) : parseInt(fallback);
            };
            return {
                creator: getLimit("QR Slots", "15"),
                qrDecoder: getLimit("QR Decoding History", "15"),
                barcodeDecoder: getLimit("Barcode Decoding History", "50"),
                barcodeCreator: 50
            };
        };

        window.trimAllHistoriesToLimits = async function () {
            try {
                const limits = window.getCurrentStorageLimits();

                // 1. QR Creator & Barcode Creator (in QRHistoryDB -> creator_history)
                if (window.QRHistoryDB && typeof window.QRHistoryDB.getAll === 'function') {
                    const creatorItems = await window.QRHistoryDB.getAll('creator_history');
                    const qrItems = creatorItems.filter(i => i.type !== 'barcode');
                    const barcodeItems = creatorItems.filter(i => i.type === 'barcode');

                    // Trim QR items
                    if (qrItems.length > limits.creator) {
                        const sortedQr = qrItems.sort((a, b) => {
                            const valA = parseFloat(a.id || a.time || a.timestamp) || 0;
                            const valB = parseFloat(b.id || b.time || b.timestamp) || 0;
                            return valA - valB;
                        });
                        let toDelete = sortedQr.filter(i => !i.isFavorite);
                        if (toDelete.length < qrItems.length - limits.creator) {
                            toDelete = sortedQr; // fallback to deleting favorites if needed
                        }
                        const countToDelete = qrItems.length - limits.creator;
                        const itemsToDelete = toDelete.slice(0, countToDelete);
                        for (const oldItem of itemsToDelete) {
                            await window.QRHistoryDB.deleteItem('creator_history', oldItem.id || oldItem.time);
                        }
                    }

                    // Trim Barcode items
                    if (barcodeItems.length > limits.barcodeCreator) {
                        const sortedBarcode = barcodeItems.sort((a, b) => {
                            const valA = parseFloat(a.id || a.time || a.timestamp) || 0;
                            const valB = parseFloat(b.id || b.time || b.timestamp) || 0;
                            return valA - valB;
                        });
                        let toDelete = sortedBarcode.filter(i => !i.isFavorite);
                        if (toDelete.length < barcodeItems.length - limits.barcodeCreator) {
                            toDelete = sortedBarcode;
                        }
                        const countToDelete = barcodeItems.length - limits.barcodeCreator;
                        const itemsToDelete = toDelete.slice(0, countToDelete);
                        for (const oldItem of itemsToDelete) {
                            await window.QRHistoryDB.deleteItem('creator_history', oldItem.id || oldItem.time);
                        }
                    }

                    // Trim Barcode Decoder (decoder_history)
                    const decoderItems = await window.QRHistoryDB.getAll('decoder_history');
                    if (decoderItems.length > limits.barcodeDecoder) {
                        const sortedDec = decoderItems.sort((a, b) => {
                            const valA = parseFloat(a.time || a.timestamp) || 0;
                            const valB = parseFloat(b.time || b.timestamp) || 0;
                            return valA - valB;
                        });
                        let toDelete = sortedDec.filter(i => !i.isFavorite);
                        if (toDelete.length < decoderItems.length - limits.barcodeDecoder) {
                            toDelete = sortedDec;
                        }
                        const countToDelete = decoderItems.length - limits.barcodeDecoder;
                        const itemsToDelete = toDelete.slice(0, countToDelete);
                        for (const oldItem of itemsToDelete) {
                            await window.QRHistoryDB.deleteItem('decoder_history', oldItem.time);
                        }
                    }
                }

                // Trim QR Decoder (in QRDecoderHistoryDB)
                if (window.QRDecoderHistoryDB && typeof window.QRDecoderHistoryDB.getAll === 'function') {
                    if (!window.QRDecoderHistoryDB.db) await window.QRDecoderHistoryDB.init();
                    const qrDecodedItems = await window.QRDecoderHistoryDB.getAll('qr_decoder_history');
                    if (qrDecodedItems.length > limits.qrDecoder) {
                        const sortedDec = qrDecodedItems.sort((a, b) => {
                            const valA = parseFloat(a.time || a.timestamp) || 0;
                            const valB = parseFloat(b.time || b.timestamp) || 0;
                            return valA - valB;
                        });
                        let toDelete = sortedDec.filter(i => !i.isFavorite);
                        if (toDelete.length < qrDecodedItems.length - limits.qrDecoder) {
                            toDelete = sortedDec;
                        }
                        const countToDelete = qrDecodedItems.length - limits.qrDecoder;
                        const itemsToDelete = toDelete.slice(0, countToDelete);
                        for (const oldItem of itemsToDelete) {
                            await window.QRDecoderHistoryDB.deleteItem('qr_decoder_history', oldItem.time);
                        }
                    }
                }

                if (typeof window.syncUsedSlotsToFirebase === 'function') window.syncUsedSlotsToFirebase();

            } catch (err) {
                console.error("Error trimming history to limits:", err);
            }
        };

        window.syncParentSubscription = function () {
            try {
                // Ensure restricted keys are absent from localStorage
                RESTRICTED_STORAGE_KEYS.forEach(k => {
                    try { originalRemoveItem.call(localStorage, k); } catch (e) { }
                });

                let sub = 'normal';
                // 🔐 Firebase-first: If BloomSubscription is initialized and user logged in, it is authority
                if (window.BloomSubscription && window.suiteAuth && window.suiteAuth.currentUser) {
                    const TIER_TO_INTERNAL = { 'foundation': 'normal', 'velocity': 'max', 'quantum': 'pro', 'ultra': 'ultra' };
                    const cached = window.BloomSubscription.getPlanData();
                    if (cached && cached.plan) {
                        sub = TIER_TO_INTERNAL[cached.plan] || cached.plan;
                    }
                } else {
                    const coldSub = getVerifiedPlanFromCache();
                    sub = coldSub || 'normal';
                }

                let oldSub = window._last_notified_subscription;
                if (!oldSub) {
                    oldSub = 'normal';
                    window._last_notified_subscription = oldSub;
                }

                if (oldSub !== sub) {
                    const TIER_RANK = { 'foundation': 0, 'normal': 0, 'max': 1, 'velocity': 1, 'pro': 2, 'quantum': 2, 'ultra': 3 };
                    const oldLevel = TIER_RANK[oldSub] !== undefined ? TIER_RANK[oldSub] : -1;
                    const newLevel = TIER_RANK[sub] !== undefined ? TIER_RANK[sub] : -1;

                    if (oldSub && oldLevel !== -1 && newLevel !== -1) {
                        if (newLevel > oldLevel) {
                            const newPlanName = (window.planFullData[sub] || { name: sub.toUpperCase() }).name;
                            if (typeof window.addSuiteNotification === 'function') {
                                window.addSuiteNotification('account', 'Subscription Upgraded', `Your plan has been upgraded to ${newPlanName}. Enjoy higher limits and premium features!`, { 'New Plan': newPlanName, 'Status': 'Active' });
                            }
                            // Only fire celebration when plan genuinely upgrades
                            try { originalSetItem.call(localStorage, 'pending_celebration', 'true'); } catch (e) { }
                        } else if (newLevel < oldLevel) {
                            const newPlanName = (window.planFullData[sub] || { name: sub.toUpperCase() }).name;
                            if (typeof window.addSuiteNotification === 'function') {
                                window.addSuiteNotification('account', 'Subscription Downgraded', `Your plan has been downgraded to ${newPlanName}.`, { 'New Plan': newPlanName, 'Status': 'Active' });
                            }
                            if (typeof window.trimAllHistoriesToLimits === 'function') window.trimAllHistoriesToLimits();
                        }
                    }

                    if (newLevel > oldLevel) {
                        window._qrbloom_batch_usage = 0;
                        window.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { key: 'qr_batch_usage', val: '0', newValue: '0' } }));
                        if (typeof window.syncBatchUsageToFirebase === 'function') window.syncBatchUsageToFirebase(0);
                    }

                    window._last_notified_subscription = sub;
                    try { originalRemoveItem.call(localStorage, 'last_notified_subscription'); } catch (e) { }
                    window.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { key: 'user_subscription', val: sub, newValue: sub } }));
                    document.querySelectorAll('iframe').forEach(iframe => {
                        try { if (iframe.contentWindow) iframe.contentWindow.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { key: 'user_subscription', val: sub, newValue: sub } })); } catch (err) { }
                    });

                    if (newLevel !== -1 && oldLevel !== -1 && newLevel < oldLevel) {
                        if (typeof window.trimAllHistoriesToLimits === 'function') window.trimAllHistoriesToLimits();
                    }
                }
            } catch (e) {
                console.error("Error in syncParentSubscription:", e);
            }
        };

        // Run sync on startup in the parent window
        window.syncParentSubscription();

        // 🛡️ CONTINUOUS TAMPER GUARD: Instantly purges restricted keys and reverts plan if modified
        function enforceTamperGuard() {
            let tampered = false;
            for (const k of RESTRICTED_STORAGE_KEYS) {
                if (originalGetItem.call(localStorage, k) !== null) {
                    originalRemoveItem.call(localStorage, k);
                    tampered = true;
                }
            }
            if (tampered) {
                const authenticPlan = (window.BloomSubscription && typeof window.BloomSubscription.getActivePlan === 'function')
                    ? window.BloomSubscription.getActivePlan()
                    : getVerifiedPlanFromCache();
                window.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { key: 'user_subscription', val: authenticPlan, newValue: authenticPlan } }));
                window.dispatchEvent(new CustomEvent('storage', { key: 'user_subscription', newValue: authenticPlan }));
                window.dispatchEvent(new CustomEvent('qrbloom_plan_tampered', { detail: { plan: authenticPlan } }));
                document.querySelectorAll('iframe').forEach(iframe => {
                    try {
                        if (iframe.contentWindow) {
                            iframe.contentWindow.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { key: 'user_subscription', val: authenticPlan, newValue: authenticPlan } }));
                            iframe.contentWindow.dispatchEvent(new CustomEvent('storage', { key: 'user_subscription', newValue: authenticPlan }));
                            iframe.contentWindow.dispatchEvent(new CustomEvent('qrbloom_plan_tampered', { detail: { plan: authenticPlan } }));
                        }
                    } catch (e) { }
                });
            }
        }
        setInterval(enforceTamperGuard, 150);
        window.addEventListener('storage', (e) => {
            enforceTamperGuard();
            if (e.key === 'qr_bloom_purchase_history' || e.key === 'premiumActive' || e.key === 'user_subscription') {
                window.syncParentSubscription();
            }
        });
        window.addEventListener('safeStorageChange', (e) => {
            if (e.detail && (e.detail.key === 'qr_bloom_purchase_history' || e.detail.key === 'premiumActive' || e.detail.key === 'user_subscription')) {
                window.syncParentSubscription();
            }
        });
        window.addEventListener('focus', enforceTamperGuard);

        window.QRHistoryDB = {
            db: null,
            init: function () {
                return new Promise((resolve, reject) => {
                    const request = indexedDB.open("QRBloomDB", 4);
                    request.onupgradeneeded = (e) => {
                        const db = e.target.result;
                        if (!db.objectStoreNames.contains("creator_history")) {
                            db.createObjectStore("creator_history", { keyPath: "id" });
                        }
                        if (!db.objectStoreNames.contains("decoder_history")) {
                            db.createObjectStore("decoder_history", { keyPath: "time" });
                        }
                    };
                    request.onsuccess = (e) => {
                        this.db = e.target.result;
                        resolve(this.db);
                    };
                    request.onerror = (e) => reject(e);
                });
            },
            addItem: function (storeName, item, limit) {
                return new Promise(async (resolve, reject) => {
                    try {
                        if (!this.db) await this.init();
                        const all = await this.getAll(storeName);
                        const itemType = item.type || (storeName === 'creator_history' ? 'qr' : (item.format && !String(item.format).toLowerCase().includes('qr') ? 'barcode' : 'qr'));
                        const sameTypeItems = all.filter(i => {
                            const t = i.type || (storeName === 'creator_history' ? 'qr' : (i.format && !String(i.format).toLowerCase().includes('qr') ? 'barcode' : 'qr'));
                            return t === itemType && !!i.isDynamic === !!item.isDynamic;
                        });
                        const exists = sameTypeItems.some(i =>
                            (item.id !== undefined && i.id === item.id) ||
                            (item.time !== undefined && i.time === item.time)
                        );
                        const tx = this.db.transaction(storeName, "readwrite");
                        const store = tx.objectStore(storeName);
                        if (!exists && sameTypeItems.length >= limit) {
                            const sorted = sameTypeItems.sort((a, b) => {
                                const valA = parseFloat(a.id || a.time || a.timestamp) || 0;
                                const valB = parseFloat(b.id || b.time || b.timestamp) || 0;
                                return valA - valB;
                            });
                            let toDelete = sorted.filter(i => !i.isFavorite);
                            if (toDelete.length === 0) {
                                toDelete = sorted;
                            }
                            const countToDelete = (sameTypeItems.length - limit) + 1;
                            const itemsToDelete = toDelete.slice(0, countToDelete);
                            itemsToDelete.forEach(oldItem => {
                                store.delete(oldItem.id || oldItem.time);
                            });
                        }
                        store.put(item);
                        tx.oncomplete = () => { resolve(); if (window.syncUsedSlotsToFirebase) window.syncUsedSlotsToFirebase(); };
                        tx.onerror = (e) => reject(e);
                    } catch (err) {
                        reject(err);
                    }
                });
            },
            deleteItem: function (storeName, id) {
                return new Promise(async (resolve, reject) => {
                    if (!this.db) await this.init();
                    const tx = this.db.transaction(storeName, "readwrite");
                    const store = tx.objectStore(storeName);
                    store.delete(id);
                    tx.oncomplete = () => { resolve(); if (window.syncUsedSlotsToFirebase) window.syncUsedSlotsToFirebase(); };
                    tx.onerror = (e) => reject(e);
                });
            },
            deleteByType: function (storeName, type) {
                return new Promise(async (resolve, reject) => {
                    if (!this.db) await this.init();
                    const all = await this.getAll(storeName);
                    const targetType = type.includes('qr') ? 'qr' : 'barcode';
                    const toDelete = all.filter(i => i.type === targetType);

                    const tx = this.db.transaction(storeName, "readwrite");
                    const store = tx.objectStore(storeName);
                    toDelete.forEach(item => {
                        store.delete(item.id || item.time);
                    });
                    tx.oncomplete = () => { resolve(); if (window.syncUsedSlotsToFirebase) window.syncUsedSlotsToFirebase(); };
                    tx.onerror = (e) => reject(e);
                });
            },
            getAll: function (storeName) {
                return new Promise(async (resolve, reject) => {
                    if (!this.db) await this.init();
                    const tx = this.db.transaction(storeName, "readonly");
                    const store = tx.objectStore(storeName);
                    const request = store.getAll();
                    request.onsuccess = () => {
                        const data = request.result.sort((a, b) => {
                            const valA = parseFloat(a.timestamp || a.id || a.time) || 0;
                            const valB = parseFloat(b.timestamp || b.id || b.time) || 0;
                            return valB - valA;
                        });
                        resolve(data);
                    };
                    request.onerror = (e) => reject(e);
                });
            },
            clearStore: function (storeName) {
                return new Promise(async (resolve, reject) => {
                    if (!this.db) await this.init();
                    const tx = this.db.transaction(storeName, "readwrite");
                    const store = tx.objectStore(storeName);
                    store.clear();
                    tx.oncomplete = () => { resolve(); if (window.syncUsedSlotsToFirebase) window.syncUsedSlotsToFirebase(); };
                    tx.onerror = (e) => reject(e);
                });
            }
        };

        window.QRDecoderHistoryDB = {
            db: null,
            init: function () {
                return new Promise((resolve, reject) => {
                    const request = indexedDB.open("QRDecoderHistoryDB", 4);
                    request.onupgradeneeded = (e) => {
                        const db = e.target.result;
                        if (!db.objectStoreNames.contains("qr_decoder_history")) {
                            db.createObjectStore("qr_decoder_history", { keyPath: "time" });
                        }
                    };
                    request.onsuccess = (e) => {
                        this.db = e.target.result;
                        resolve(this.db);
                    };
                    request.onerror = (e) => reject(e);
                });
            },
            addItem: function (storeName, item, limit) {
                return new Promise(async (resolve, reject) => {
                    try {
                        if (!this.db) await this.init();
                        const all = await this.getAll(storeName);
                        const exists = all.some(i => i.time === item.time);
                        const tx = this.db.transaction(storeName, "readwrite");
                        const store = tx.objectStore(storeName);
                        if (!exists && all.length >= limit) {
                            const sorted = all.sort((a, b) => {
                                const valA = parseFloat(a.time || a.timestamp) || 0;
                                const valB = parseFloat(b.time || b.timestamp) || 0;
                                return valA - valB;
                            });
                            let toDelete = sorted.filter(i => !i.isFavorite);
                            if (toDelete.length === 0) {
                                toDelete = sorted;
                            }
                            const countToDelete = (all.length - limit) + 1;
                            const itemsToDelete = toDelete.slice(0, countToDelete);
                            itemsToDelete.forEach(oldItem => {
                                store.delete(oldItem.time);
                            });
                        }
                        store.put(item);
                        tx.oncomplete = () => { resolve(); if (window.syncUsedSlotsToFirebase) window.syncUsedSlotsToFirebase(); };
                        tx.onerror = (e) => reject(e);
                    } catch (err) {
                        reject(err);
                    }
                });
            },
            deleteItem: function (storeName, id) {
                return new Promise(async (resolve, reject) => {
                    if (!this.db) await this.init();
                    const tx = this.db.transaction(storeName, "readwrite");
                    const store = tx.objectStore(storeName);
                    store.delete(id);
                    tx.oncomplete = () => { resolve(); if (window.syncUsedSlotsToFirebase) window.syncUsedSlotsToFirebase(); };
                    tx.onerror = (e) => reject(e);
                });
            },
            getAll: function (storeName) {
                return new Promise(async (resolve, reject) => {
                    if (!this.db) await this.init();
                    const tx = this.db.transaction(storeName, "readonly");
                    const store = tx.objectStore(storeName);
                    const request = store.getAll();
                    request.onsuccess = () => {
                        const data = request.result.sort((a, b) => {
                            const valA = parseFloat(a.timestamp || a.time) || 0;
                            const valB = parseFloat(b.timestamp || b.time) || 0;
                            return valB - valA;
                        });
                        resolve(data);
                    };
                    request.onerror = (e) => reject(e);
                });
            },
            clearStore: function (storeName) {
                return new Promise(async (resolve, reject) => {
                    if (!this.db) await this.init();
                    const tx = this.db.transaction(storeName, "readwrite");
                    const store = tx.objectStore(storeName);
                    store.clear();
                    tx.oncomplete = () => { resolve(); if (typeof window.syncUsedSlotsToFirebase === 'function') window.syncUsedSlotsToFirebase(); };
                    tx.onerror = (e) => reject(e);
                });
            }
        };

        window.addSuiteNotification = function (type, title, message, detail = {}) {
            let notifs = [];
            try {
                const raw = localStorage.getItem('qr_bloom_notifications');
                if (raw) {
                    notifs = JSON.parse(raw);
                } else {
                    notifs = [];
                }
            } catch (e) {
                notifs = [];
            }

            // Prevent exact identical notifications within 5 seconds to avoid double-logging/spamming
            const isDuplicate = notifs.some(n =>
                n.title === title &&
                n.message === message &&
                (Date.now() - (n.timestamp || 0) < 5000)
            );
            if (isDuplicate) return;

            const iconMap = {
                scan: 'qr_code_scanner',
                create: 'add_box',
                account: 'person',
                system: 'info'
            };

            const newNotif = {
                id: 'n_' + Date.now() + '_' + Math.random().toString(36).substr(2, 5),
                type: type,
                icon: iconMap[type] || 'info',
                title: title,
                message: message,
                time: 'Just now',
                timeGroup: 'today',
                timestamp: Date.now(),
                read: false,
                detail: detail
            };

            notifs.unshift(newNotif);
            safeStorage.setItem('qr_bloom_notifications', JSON.stringify(notifs));
        };

        window.checkStorageNotifications = async function () {
            try {
                const limits = window.getCurrentStorageLimits();

                // 1. QR Creator
                let qrCreated = 0;
                try {
                    const creatorItems = await window.QRHistoryDB.getAll('creator_history');
                    qrCreated = creatorItems.filter(i => i.type !== 'barcode').length;
                } catch (e) { }

                // 2. Barcode Creator
                let barcodesCreated = 0;
                try {
                    const creatorItems = await window.QRHistoryDB.getAll('creator_history');
                    barcodesCreated = creatorItems.filter(i => i.type === 'barcode').length;
                } catch (e) { }

                // 3. QR Decoder
                let qrDecoded = 0;
                try {
                    if (!window.QRDecoderHistoryDB.db) await window.QRDecoderHistoryDB.init();
                    const qrDecodedItems = await window.QRDecoderHistoryDB.getAll('qr_decoder_history');
                    qrDecoded = qrDecodedItems.length;
                } catch (e) { }

                // 4. Barcode Decoder
                let barcodesDecoded = 0;
                try {
                    const decoderItems = await window.QRHistoryDB.getAll('decoder_history');
                    barcodesDecoded = decoderItems.length;
                } catch (e) { }

                if (qrCreated >= limits.creator) {
                    window.addSuiteNotification('create', 'QR Creator Limit Reached', `You have reached the plan limit of ${limits.creator} QR codes. Upgrade your plan for more slots.`, { limit: String(limits.creator), current: String(qrCreated), action: 'Upgrade Required' });
                }
                if (barcodesCreated >= limits.barcodeCreator) {
                    window.addSuiteNotification('create', 'Barcode Creator Limit Reached', `You have reached the capacity limit of ${limits.barcodeCreator} barcodes.`, { limit: String(limits.barcodeCreator), current: String(barcodesCreated), action: 'Clean History' });
                }
                if (qrDecoded >= limits.qrDecoder) {
                    window.addSuiteNotification('scan', 'QR Decoder Limit Reached', `Your QR scan history is full (${limits.qrDecoder}/${limits.qrDecoder}). Older scans will be cycled.`, { limit: String(limits.qrDecoder), current: String(qrDecoded), action: 'Cycle Active' });
                }
                if (barcodesDecoded >= limits.barcodeDecoder) {
                    window.addSuiteNotification('scan', 'Barcode Decoder Limit Reached', `Your barcode scan history is full (${limits.barcodeDecoder}/${limits.barcodeDecoder}). Older scans will be cycled.`, { limit: String(limits.barcodeDecoder), current: String(barcodesDecoded), action: 'Cycle Active' });
                }
            } catch (err) {
                console.error("Error checking storage limits:", err);
            }
        };

        // Bridge: Global Notification Proxy for internal scripts
        window.pop = (msg, type = 'info') => {
            if (typeof showNotification === 'function') {
                showNotification('CLOUD SECURITY', msg, type);
            } else if (typeof showToast === 'function') {
                showToast(msg, type === 'error');
            } else {
                console.warn(`[Portal Fallback] ${type}: ${msg}`);
            }
        };

        // Expose _getAppSecret globally
        window._getAppSecret = _getAppSecret;